import { useState } from 'react';

import { Button } from '../../../cdl/Button/Button';
import { useToasts } from '../../../cdl/Toast/useToasts';
import { translate } from '../../../common/helpers/translate.helper';
import { useRole } from '../../../common/hooks/useRole';
import { IconPlus } from '../../../common/icons/cdl/Plus';
import { useAssignmentList } from '../../common/hooks/useAssignmentList';
import { useSpotAvailableAtPort } from '../../create-enquiry/hooks/useSpotAvailableAtPort';
import { OrderModel } from '../../model/OrderModel';

import { RequestSuppliersModal } from './RequestSuppliersModal';

interface RequestSuppliersButtonProps {
    order: OrderModel;
}

export const RequestSuppliersButton = (props: RequestSuppliersButtonProps) => {
    const [showModal, setShowModal] = useState(false);
    const role = useRole();
    const { addErrorToast } = useToasts();

    const assignmentQuery = useAssignmentList(props.order.customerId, props.order.portId, props.order.testOrder);
    const spotAvailableQuery = useSpotAvailableAtPort(
        props.order.port?.country?.code,
        props.order.testOrder,
        !role.isSuperAdmin()
    );

    if (!assignmentQuery.data) {
        return null;
    }

    const hasSuppliersToInvite = assignmentQuery.data.some(
        (assignment) => !props.order.receiverSupplierIds.includes(assignment.supplierId)
    );

    const canAddSpot =
        role.isSpotAllowed(props.order.customerId) && spotAvailableQuery.data?.available === true && !props.order.spot;
    const moreSuppliersToInvite = hasSuppliersToInvite || canAddSpot;

    const buttonHidden =
        !moreSuppliersToInvite ||
        role.isSuperAdmin() ||
        !role.hasWriteRights(props.order.customerId) ||
        props.order.isFinished();

    if (buttonHidden) {
        return null;
    }

    return (
        <>
            <Button onClick={() => setShowModal(true)} LeadingIcon={IconPlus}>
                {translate('order.detail.requestSuppliers.button')}
            </Button>
            {showModal ? (
                <RequestSuppliersModal
                    assignments={assignmentQuery.data}
                    order={props.order}
                    onClose={(error) => {
                        if (error) {
                            addErrorToast(translate('order.detail.requestSuppliers.errorToast'));
                        }
                        setShowModal(false);
                    }}
                />
            ) : null}
        </>
    );
};
